module.exports = __webpack_public_path__ + "media/images/logo_white-6950984a.svg";